import BasicLayout from "@components/layouts/basic";
import SignupAccount from "@components/signup/account";
import { Box, Container } from "@material-ui/core";
import React from "react";

export default function Page() {
  return (
    <BasicLayout title="Sign Up - Account Set Up">
      <Box py={2}>
        <Container maxWidth="xs">
          <SignupAccount />
        </Container>
      </Box>
    </BasicLayout>
  );
}
